import useBoostMultLockedVno from '@ui/hooks/useBoostMultLockedVno';
import {
  useNftsWithMultipliers,
  useNumberOfStakedNfts,
  useStakedNfts,
} from '@ui/hooks/useCruisers';

import { useGrowHelpers } from '../GrowHelpersProvider';

const useStakeNftInfo = () => {
  const { gardenType } = useGrowHelpers();
  const nfts = useNftsWithMultipliers();
  const { boostMultiplier: multFromLocked } = useBoostMultLockedVno();
  const { data: stakedCruisers } = useStakedNfts(gardenType);
  const currentNftBoost = stakedCruisers
    ? stakedCruisers.reduce((prev, c) => c.multiplier + prev, 0)
    : undefined;

  const { data: numberOfStakedCruisers } = useNumberOfStakedNfts(gardenType);
  const maxNForStake =
    numberOfStakedCruisers !== undefined
      ? 5 - numberOfStakedCruisers
      : undefined;
  return {
    nfts,
    currentNftBoost,
    multFromLocked,
    maxNForStake,
    numberOfStakedCruisers,
  };
};

export default useStakeNftInfo;
